<div class="expandable-children">
  <div class="children-scroll-container">
    @for (child of displayedChildren(); track child.url || child.uri || $index) {
      <a
        class="child-item body-s bold"
        [routerLink]="child.url"
        [routerLinkActive]="'active'"
        (click)="onChildClick($event, child)"
        tabindex="0"
        role="button"
      >
        <span class="child-title">{{ child.title }}</span>
      </a>
    }
  </div>

  @if (hasMore()) {
    <button class="show-more-btn body-s" (click)="onShowMore($event)">
      {{ 'translations.global.button.showMore' | transloco }}
    </button>
  }
</div>
